<div class="card">
    <div class="card-body">
        <surge-table [delegate]="this" name="material-details"></surge-table>
        <surge-alert
            type="success"
            *ngIf="saved"
            messages="Everything was sent."
            (onDismiss)="saved = false"
        ></surge-alert>
        <surge-alert type="danger" *ngIf="error" [messages]="error" (onDismiss)="error = null"></surge-alert>
        <hr />
        <div class="buttons-container">
            <button surgeButton type="submit" (click)="addNewItem()">Add an item material</button>
            <button surgeButton (click)="save()" [disabled]="!canSave()" class="ml-auto" [busy]="saving">Save</button>
        </div>
    </div>
</div>
